export function postAndroidMessage(message: string): void {
  if (message === '' || typeof window === 'undefined') return;

  window.android?.postMessage(message);
}

export function isNativeAndroid(): boolean {
  return typeof window !== 'undefined' && window.android != null && navigator.userAgent.includes('lemonade');
}
